import React from 'react';
import { string } from 'prop-types';

var IconEye = function IconEye(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "25",
    height: "25",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 5.5C8.65315 5.5 5.37759 7.53616 2.16521 11.5299L1.78711 12L2.16521 12.4701C5.37759 16.4638 8.65315 18.5 11.9996 18.5C15.3461 18.5 18.6216 16.4638 21.834 12.4701L22.2121 12L21.834 11.5299C18.6216 7.53616 15.3461 5.5 11.9996 5.5ZM20.2789 12C17.4588 15.3562 14.6968 17 11.9996 17C9.30247 17 6.54047 15.3562 3.72038 12C6.54047 8.64376 9.30247 7 11.9996 7C14.6968 7 17.4588 8.64376 20.2789 12Z",
    fill: color
  }));
};

IconEye.defaultProps = {
  color: '#444749'
};
IconEye.propTypes = {
  color: string
};
export default IconEye;